import React from 'react';
import PropTypes from 'prop-types';

import APIClient from './APIClient';

class LogOut extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    setLoggedIn: PropTypes.func.isRequired,
  };

  componentDidMount() {
    APIClient.shared.setToken(null);
    this.props.setLoggedIn(false);
    this.props.history.push('/');
  }

  render() {
    return null;
  }
}

export default LogOut;



// WEBPACK FOOTER //
// ./src/LogOut.js